<template>

<div class="topnav flex flex-col items-center justify-between" id="myTopnav" :class='fixedNavClassesTop' >
  <div class="pbc-z-level-1 topnav flex items-center w-full justify-start" :class='fixedNavClasses'>
    <router-link v-if='hasCustomNavBar' tag="a" :to="{name:'new'}" class="flex flex-row" :class='hasCustomNavBar ? "mr-4" : "mr-2"'>

      <img class="w-8 h-8 my-auto ml-1 mr-0" src='/img/PBC_logo.svg' />
      <h3 v-if='!hasCustomNavBar' class="my-auto text-white font-bold text-sm">playboxcade</h3>
      <h3 v-else class="my-auto text-white font-bold text-sm">playboxcade</h3>

    </router-link>

    <router-link v-else tag="a" :to="{name:'new'}" class="flex flex-row" :class='hasCustomNavBar ? "mr-4 ml-2" : "ml-1 mr-1"'>
      <img class="w-4 h-4 md:w-10 md:h-10 my-auto ml-1 mr-0" src='/img/PBC_logo.svg' />
      <h3 class="my-auto text-white font-bold text-xs truncate md:text-lg">playboxcade</h3>
    </router-link>

    <div v-if='!hasCustomNavBar' class="grow md:w-12 md:flex-none"></div>
    <div v-if='!hasCustomNavBar' class="flex flex-row flex-none justify-center text-white">

      <router-link :to="isHot ? {name:'new'} : {name:'hot'}" class="mr-2 w-12 py-2 mx-0">
        <new-or-hot :value='isHot' />
      </router-link>
    </div>

    <div v-if='!hasCustomNavBar' class="grow md:flex-grow"></div>

    <!--  <a href="#news">Get Started</a>-->
    <a v-if='!hasCustomNavBar'
                 class="cursor-pointer linkanchor primaryanchor flex flex-row pbc-primary-color create-button mx-1"
                 @click='showCreate'>
      <plus-circle-outline class="mr-1" />
      <span id='create-button-label'>Create</span>
      <apollo-query id='create-button-drafts' :query='getPostDraftsQuery' class="float-left" :skip='isServer' client-id='localClient'>
        <template v-slot="{ result: { loading, error, data } }">
          <span v-if='data && data.postDrafts && data.postDrafts.length' class="bg-orange-400 text-black ml-1 p-1 rounded">{{data.postDrafts.length}}</span>
        </template>
      </apollo-query>

    </a>

    <!--
    <router-link v-if='!hasCustomNavBar'
                 class="linkanchor"
                 tag="a"
                 :to="{name:'help'}"
                 :exact='true'
                 active-class="active text-center">Help</router-link>
    -->

    <!--
    <button class="inline-flex flex-grow-0 items-center">
      <img class="w-10 h-10 m-0 md:m-1" src='/discord-512.png'/>
      <span class="ml-1 text-left text-white text-xs md:text-sm" @click="toggleDiscord">Want to Chat?</span>
    </button>
    -->

    <div v-if='!hasCustomNavBar' class="grow"></div>
    <span class="hidden lg:block text-xs text-blue-800 flex-none mr-6">
        {{buildNumber}}
    </span>
    <router-link v-if='!isAyoba && !hasCustomNavBar && (!user || user.anonymous)'
                  class="linkanchor text-xs h-8 md:text-base"
                  :class='localMemes.length ? "bg-orange-600" : ""'
                  tag="a" 
                  :to="{name:'login'}" 
                  :exact='true'
                  exact-active-class="active text-center">
      Login
      <span id="local-memes-count" v-show='localMemes && localMemes.length' class="bg-orange-400 text-black ml-1 p-1 rounded">{{localMemes.length}}</span>
    </router-link>
    <div v-else-if='isAyoba' class="grow flex flex-row justify-end">
      <button class="transparent-button flex flex-row" @click='showHelp = true'>
        <comment-quote :size='32' />
        <span class="text-xs ml-2">Feedback</span>
      </button>
    </div>

    <portal-target v-if='hasCustomNavBar'
                   class='grow'
                   name='customNavBar' />

    <big-user v-if='hasCustomNavBar && user && user.id !== "anonymous"'
              :user='user'
              class="text-white mr-1 truncate hidden md:flex"
              />
    <big-user v-else-if='user && user.id !== "anonymous"'
              :user='user'
              class='text-white mr-1'>
      <span v-show='localMemes && localMemes.length' class="bg-orange-400 text-black ml-1 p-1 rounded">{{localMemes.length}}</span>
    </big-user>
      <!--
      <div class="text-white">
        {{viewPosts}}
      </div>
      -->
      <!--
    <big-user v-else-if='hasCustomNavBar && user && user.id !== "anonymous"'
              :user='user'
              class="text-white text-xs w-8 truncate" />
      -->


      <portal v-if='showCreatePopup' to="main-modal">
       <pbc-popup v-if='showCreatePopup' @close='dismissCreate'>
          <create-dialog @close='dismissCreate' />
       </pbc-popup>
      </portal>

      <portal v-if='showHelp' to="last-modal">
        <pbc-overlay @close='showHelp = false' @done='showHelp = false'>
          <div class="bg-gray-300 p-1 grow overflow-hidden flex flex-col">
            <pbc-cta-help class="overflow-y-auto grow" />
          </div>
        </pbc-overlay>
      </portal>

  </div>

</div>

</template>

<script>
import PbcCtaHelp from '@ui/atoms/PbcCtaHelp.vue';
import NewOrHot from '@ui/atoms/NewOrHot.vue';
import CreateDialog from '@ui/organisms/CreateDialog.vue';
import PlusCircleOutline from '@icons/PlusCircleOutline.vue';
import PbcPopup from '@ui/molecules/PbcPopup.vue';
import { mapState } from 'vuex';
import { ApolloQuery } from 'vue-apollo';
import { getPostDraftsQuery, getLocalMemes } from '@/gql/Queries.js';
import gql from 'graphql-tag';
//import { ApolloMutation } from 'vue-apollo';
import BigUser from '@ui/atoms/BigUser.vue';
import CommentQuote from '@icons/CommentQuote.vue';
export default {
  props: {
    user: {
      type: Object,
      required: false
    }
  },
  apollo: {
    localMemes: {
      query: getLocalMemes,
      client: 'localClient',
      skip() {
        return this.isServer;
      }
    }
  },
  inject:['api'],
  data () {
    return {
      getPostDraftsQuery,
      getLocalMemes,
      lolVueRouter: false,
      buildNumber: process.env.VUE_APP_BUILD_NUMBER || 'cheese',
      localMemes: [],
      showHelp: false
    }
  },
  components: {
    //ApolloMutation,
    BigUser,
    NewOrHot,
    //PbcPopup,
    CreateDialog,
    ApolloQuery,
    PlusCircleOutline,
    CommentQuote,
    PbcCtaHelp
  },
  mounted() {
    this.$eventbus.on('create', () => {
      this.showCreate();
    });
  },
  methods: {
    showCreate() {
      this.lolVueRouter = true;
      this.$router.push({
        query:{
          prompt:true
        }
      });
    },
    dismissCreate() {
      this.lolVueRouter = false;
      this.$router.push({
        query:{
          prompt:undefined
        }
      });
    },
    navSlide() {
      const nav = document.querySelector('.navlinks');
      nav.classList.toggle('navActive');
    },
  },
  watch:{
    '$route.query.prompt'(nv) {
      this.lolVueRouter = !!nv;
    }
  },
  computed:{
    isHot: {
      get() {
        const anyRouteIsHot = this.$route.matched.filter( ({name}) => {
          return name === 'hot';
        }).length > 0;
        const anyRouteIsNew = this.$route.matched.filter( ({name}) => {
          return name === 'new';
        }).length > 0;
        return anyRouteIsHot && !anyRouteIsNew;
      }
    },
    isServer() {
      return !process.browser;
    },
    hasCustomNavBar() {
      return !this.isAdvancedMode && (this.$route.name === 'create' || this.$route.name === 'template');
    },
    fixedNavClasses() {
      return ['h-12'];
    },
    fixedNavClassesTop() {
      if (this.$route.name === 'play') {
        //return ['h-10 sticky bottom-0 pbc-z-level-4'];
        return ['h-12'];
      } else {
        return ['h-12'];
      }
    },
    showCreatePopup() {
      return this.lolVueRouter || this.$route.query.prompt === "true";
    },
    ...mapState(['isAdvancedMode', 'viewingPostId', 'viewPosts', 'isAyoba'])
  }
}
</script>
<style>
.modal {
  transition: opacity 0.25s ease;
}
body.modal-active {
  overflow-x: hidden;
  overflow-y: visible !important;
}
.pbc-title {
  color: #7F3C3C;
}
.is-active-nav {
  background-color:#e36969;
  color:white;
}
.top-navbar-item:hover {
  background-color:#e36969 !important;
  color:white !important;
}

.topnav {
  overflow: hidden;
  background-color: #1A205C;

}

/* Style the links inside the navigation bar */
.linkanchor {
  float: left;
  color: #f2f2f2;
  text-align: center;
  text-decoration: none;

  @apply rounded border border-white mr-1 py-1 px-1;
}

.primaryanchor {
}


.burger div {
width: 25px;
height: 3px;
background-color: #ff7676;
margin: 5px;
}

.burger {
  display: none;
}

/* Change the color of links on hover */
.navlinks a:hover {
  background-color: #ddd;
  color: black;
}

/* Add an active class to highlight the current page */
.topnav a.active {
  background-color: #ff7676;
  color: white;
}


/* Hide the link that should open and close the topnav on small screens */

@media screen and (max-width: 600px) {
  /* .navlinks a:not(:first-child) {display: none;} */
 
  .navlinks {
    position: absolute;
    right: 0px;
    top: 55px;
    flex-direction: column;
    background-color: #333;
    width: 150px;
    z-index: 20;
    transform: translateX(100%);
    transition: transform 0.5s ease-in;
    margin-right: 5px;
  }
  
  .burger {
    display: block;
  }

.navActive {
  transform: translateX(0%);
   
}

}

@media (max-width:360px) {
  #local-memes-count {
    display: none;
  }
  .create-button #create-button-label {
  }
  .create-button #create-button-drafts {
    display: none;
  }
}

</style>
